export default __webpack_public_path__ + "static/media/icon back.51dc414a.svg";